import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class OmitIfEmpty extends BaseOption {
  static userInterfaceComponent = {
    label: "Omit If Empty",
    component: inspectorTools.RADIO_BAR,
    optionDataType: BaseOption.DataType.Boolean,
    descriptionMessage:
      "Render nothing at all when the feed has no items — no empty state and no wrapper, "
      + "so the feed contributes no gap to its parent.",
    props: {
      options: [
        {
          label: "Yes",
          value: true,
          tooltip: "",
        },
        {
          label: "No",
          value: false,
          tooltip: "",
        },
      ],
    },
  };

  static defaultValue = false;
}
